import * as React from "react";
import moment from "moment";
import EventItem from "./event-item";
import CONSTS from "../../consts";
const _ = require('lodash');
export default class EventListing extends React.Component {
    constructor(props) {
        super(props);
        this.nextPage = () => {
            let events = _.chain(this.props.events)
                .filter((event) => {
                return this.state.SelectedMonth != "" ?
                    moment(event.StartDate).format("MMMM") === this.state.SelectedMonth :
                    true;
            })
                .groupBy((event) => {
                return moment(new Date(event.StartDate)).format('L');
            })
                .toArray()
                .value();
            if ((this.state.page + 1) * 2 < events.length) {
                this.setState({
                    page: this.state.page + 1
                });
            }
        };
        this.prevPage = () => {
            if (this.state.page - 1 >= 0) {
                this.setState({
                    page: this.state.page - 1
                });
            }
        };
        this.changeMonth = (month) => {
            this.setState({
                page: 0,
                SelectedMonth: month
            });
        };
        this.state = {
            page: 0,
            months: [""],
            SelectedMonth: ""
        };
    }
    componentWillReceiveProps(nextProps) {
        let months = _.chain(nextProps.events)
            .map((event) => {
            return moment(event.StartDate).format("MMMM");
        })
            .uniq()
            .value();
        this.setState({ months, SelectedMonth: months[0] });
    }
    componentDidMount() {
        if (this.props.events.length) {
            let months = _.chain(this.props.events)
                .map((event) => {
                return moment(event.StartDate).format("MMMM");
            })
                .uniq()
                .value();
            this.setState({ months, SelectedMonth: months[0] });
        }
    }
    render() {
        let firstEvents, secondEvents = null;
        let events = _.chain(this.props.events)
            .filter((event) => {
            return this.state.SelectedMonth != "" ?
                moment(event.StartDate).format("MMMM") === this.state.SelectedMonth :
                true;
        })
            .groupBy((event) => {
            return moment(new Date(event.StartDate)).format('L');
        })
            .toArray()
            .value();
        let firstDate = events.length > this.state.page * 2 ?
            events[this.state.page * 2] :
            null;
        let secondDate = events.length > this.state.page * 2 + 1 ?
            events[this.state.page * 2 + 1] :
            null;
        let firstHeader = firstDate != null ? moment(new Date(firstDate[0].StartDate)) : null;
        let secondHeader = secondDate != null ? moment(new Date(secondDate[0].StartDate)) : null;
        let monthFilters = this.state.months.map((month, index) => {
            return React.createElement("div", { key: index, className: month === this.state.SelectedMonth ? "month-pill selected" : "month-pill", onClick: () => { this.changeMonth(month); } }, month);
        });
        firstEvents = firstDate != null ? firstDate.map((event, index) => {
            return React.createElement(EventItem, Object.assign({ imgPath: `${CONSTS.STORAGEURL}/${CONSTS.EVENTCONTAINER}/${event.Id}.jpg` }, event, { key: index }));
        }) : null;
        secondEvents = secondDate != null ? secondDate.map((event, index) => {
            return React.createElement(EventItem, Object.assign({ imgPath: `${CONSTS.STORAGEURL}/${CONSTS.EVENTCONTAINER}/${event.Id}.jpg` }, event, { key: index }));
        }) : null;
        return (React.createElement("div", { className: "event-listing" },
            React.createElement("div", { className: "month-filter" }, monthFilters),
            React.createElement("div", { className: "events-slider" },
                React.createElement("div", { className: "left" },
                    React.createElement("i", { className: "fa fa-angle-left", onClick: this.prevPage })),
                React.createElement("div", { className: "content" },
                    React.createElement("div", { className: "event-date" },
                        React.createElement("div", { className: "date-header" },
                            React.createElement("span", { className: "date" }, firstHeader ? firstHeader.format("DD") : null),
                            React.createElement("span", { className: "day" }, firstHeader ? firstHeader.format("ddd") : null)),
                        React.createElement("div", { className: "date-content" }, firstEvents)),
                    React.createElement("div", { className: "event-date" },
                        React.createElement("div", { className: "date-header" },
                            React.createElement("span", { className: "date" }, secondHeader ? secondHeader.format("DD") : null),
                            React.createElement("span", { className: "day" }, secondHeader ? secondHeader.format("ddd") : null)),
                        React.createElement("div", { className: "date-content" }, secondEvents))),
                React.createElement("div", { className: "right" },
                    React.createElement("i", { className: "fa fa-angle-right", onClick: this.nextPage })))));
    }
}
;
//# sourceMappingURL=events-listing.js.map